import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Waitlist entry model
 *
 * Represents a user signup for the waitlist.
 *
 * @since 1.0.0
 */
export class Waitlist extends Model.Class<Waitlist>("Waitlist")({
  id: Model.Generated(Schema.String),
  email: Schema.NonEmptyTrimmedString,
  name: Schema.NullOr(Schema.String),
  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
